<template>
    <!-- About section start -->
    <section id="about-section" class="px-12 lg:px-32 py-16 border-stone-500 relative">
        <!-- Main text start -->
        <div class="xl:w-1/2 text-stone-500 mb-8 space-y-4">
            <p class="mb-4 font-semibold">
                {{ $t('about.intro') }}
            </p>
            <p>
                {{ $t('about.p1') }}
            </p>
            <p>
                {{ $t('about.p1-2') }}
            </p>
            <p>
                {{ $t('about.p2') }}
            </p>
            <p>
                {{ $t('about.p3') }}
            </p>
            <p>
                {{ $t('about.p4') }}
            </p>
            <p class="font-medium">
                {{ $t('about.p5') }}
            </p>
            <p>
                {{ $t('about.p6') }}
            </p>
        </div>
        <!-- Main text end -->
    </section>
    <!-- About section end -->
</template>

<script>
export default {
}
</script>